
import  ConfigureDialogContent  from "./ConfigureDialogContent";
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useSessionStore, labelMap } from "./SessionStore"; // Zustand-Store für die aktuelle Sitzung
import { useSiteSettings } from './context/SiteSettingsContext';


type ConfigureDialogProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const ConfigureDialog: React.FC<ConfigureDialogProps> = ({ open, setOpen }) => {
  const { settings: siteSettings, loading: isSiteSettingsLoading } = useSiteSettings();
  const logLevel = siteSettings?.frontend_log_level ?? 0;
  const sessionData = useSessionStore((state) => state.sessionData);

  const [promptTemplates, setPromptTemplates] = useState<any[]>([]);
  const [selectedTemplate, setSelectedTemplate] = useState<number | null>(null);
 
  const [selectedLlm, setSelectedLlm] = useState<string>("meta-llama/Llama-3.3-70B-Instruct");
  const [sessionName, setSessionName] = useState(sessionData?.name || "");


  // Dynamische, editierbare Felder aus der Dokumentation

  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (sessionData?.name) {
      setSessionName(sessionData.name);
    }
  }, [sessionData]);


  useEffect(() => {
    const fetchPromptTemplates = async () => {
      try {
        const response = await axios.get("/api/apps/fetch-templates");
        setPromptTemplates(response.data);
        if (response.data.length > 0 && selectedTemplate === null) {
          setSelectedTemplate(response.data[0].id);
        }
      } catch (error) {
        if (!isSiteSettingsLoading && logLevel >= 1) console.error("Fehler beim Laden der PromptTemplates:", error);
      }
    };

    fetchPromptTemplates();
    //const interval = setInterval(fetchPromptTemplates, 3000); // Automatische Aktualisierung alle 5 Sekunden
    //return () => clearInterval(interval); // Beim Verlassen der Komponente den Timer löschen
  }, []);





  // Funktion zum Senden der Dokumentationsanforderung
  const handleGenerateDocumentation = async () => {
    if (!selectedTemplate) {
      alert("Bitte ein Prompt-Template auswählen!");
      return;
    }
    if (!sessionData || !sessionData.id) {
      alert("Keine Sitzung ausgewählt!");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post("/api/services/generate-documentation/", {
        user_sitzung_id: sessionData.id, // Sitzungs-ID aus SessionStore
        prompt_template_id: selectedTemplate,
        llm_model: selectedLlm
      });
      setOpen(false);
    } catch (error) {
      if (!isSiteSettingsLoading && logLevel >= 1) console.error("Fehler beim Generieren der Dokumentation:", error);
      alert("Fehler beim Generieren der Dokumentation.");
    } finally {
      setLoading(false);

    }
  };

  return open ? (
    <div data-state="open" className="_Overlay_1699y_1" style={{ pointerEvents: "auto" }}>
      <div role="dialog" id="radix-6" aria-describedby="radix-14" aria-labelledby="radix-13" data-state="open" className="_Content_1699y_16 _fullScreen_1699y_60" tabIndex={-1} style={{ pointerEvents: "auto" }}>
        <div>
          <div className="tw-flex tw-justify-end">
            <button className="btn-reset  tw-bg-white tw-px-0 tw-text-gray-600 tw-sticky tw-right-0 tw-top-0" type="button" onClick={() => setOpen(false)}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className=" tw-text-primary-500 tw-font-light ">
                <path d="M16.9999 7L7 16.9999" stroke="#32768D" strokeWidth="1.25" strokeLinecap="round"></path>
                <path d="M7 7L16.9999 16.9999" stroke="#32768D" strokeWidth="1.25" strokeLinecap="round"></path>
              </svg>
            </button>
          </div>
          <div className="tw-grow tw-flex tw-flex-col">
            <div className="upload-form">
              <div className="upload-form__container">
                <div className="upload-form__container__main__header tw-w-full sm:!tw-w-[70vw]">
                  <h3 className="upload-form__container__main__h3">Neue Dokumentation generieren</h3>
                  <p className="upload-form__container__main__p">Vervollständigen Sie die Sitzungdetails um die Dokumention zu erstellen </p>
                </div>
          <ConfigureDialogContent open={open} setOpen={setOpen} />

        </div>
      </div>
    </div>
    </div>
            </div>
          </div>
  ) : null;
}
export default ConfigureDialog;